import React from 'react';
import { resolveAssetUrl } from '../../../shared/utils/assetUrl';
import '../styles/merge.css';
import { useTranslation } from 'react-i18next';
import { entityText } from '../../../i18n/entityText';

/**
 * Merge rank mark of a body part. The part icon is the same for every rank —
 * the rank is shown by this badge (rank color + number, or the badge image uploaded in admin).
 */
export default function RankBadge({ rank = 0, color, name, badgeImageUrl, size = 'sm', className = '' }) {
  const { t } = useTranslation();
  const style = { '--rank-color': color || '#9aa0a6' };
  return (
    <span
      className={`rank-badge rank-badge--${size} ${rank > 0 ? 'rank-badge--up' : ''} ${className}`}
      style={style}
      title={name
        ? t('rank.title_named', '{{name}} (rank {{n}})', { name: entityText(t, 'module_rank', rank, 'name', name), n: rank })
        : t('rank.title', 'Rank {{n}}', { n: rank })}
    >
      {badgeImageUrl ? (
        <img className="rank-badge__img" src={resolveAssetUrl(badgeImageUrl)} alt="" />
      ) : null}
      <span className="rank-badge__num">{rank}</span>
    </span>
  );
}
